// extracted by mini-css-extract-plugin
module.exports = {"root":"Markee_root__Dvfzi","markee":"Markee_markee__15jQX","markee2":"Markee_markee2__3KaPB"};